import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';

import { select } from '@angular-redux/store';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    selector: 'gl-cart-emptied-notification-modal',
    templateUrl: './cart-emptied-notification-modal.component.html',
    styleUrls: ['./cart-emptied-notification-modal.component.scss']
})
export class CartEmptiedNotificationModalComponent extends BaseComponent implements OnInit, OnDestroy {
    @ViewChild('focus') focusEl: ElementRef;

    @select(['cart', 'countdownTimer']) timeLeft$;
    showEmptiedDialog = false;

    ngOnInit() {
        this.timeLeft$.pipe(takeUntil(this.componentDestroyed$)).subscribe((timer) => {
            if (timer <= 1) {
                this.showEmptiedDialog = true;
                setTimeout(() => this.focusEl.nativeElement.focus());
            }
        });
    }

    onCloseEndedDialog() {
        this.showEmptiedDialog = false;
    }
}
